import { Link, Outlet, createFileRoute, useLocation } from '@tanstack/react-router';

import { cn } from '@/lib/utils';

// Layout de /f29 — Control F29 con barra de tabs horizontal y Outlet.
// Reorganización 2026-06-17: las pantallas "Leer F29" y "Cola declaración"
// viven como tabs internos, no como ítems sueltos del sidebar — un solo
// punto de entrada (Control F29) con sub-secciones por URL. Cada tab es
// una sub-ruta navegable (deep links siguen funcionando).

export const Route = createFileRoute('/_app/f29')({
  component: F29Layout,
});

interface F29Tab {
  readonly path: string;
  readonly label: string;
  // exact=true → activo solo cuando location === path. Necesario para
  // el tab "Control" en `/f29`, que si no se activaría también estando
  // en `/f29/leer` (startsWith).
  readonly exact?: boolean;
}

const TABS: readonly F29Tab[] = [
  { path: '/f29', label: 'Control', exact: true },
  { path: '/f29/leer', label: 'Leer F29' },
  { path: '/f29/cola', label: 'Cola declaración' },
];

function F29Layout() {
  const location = useLocation();
  return (
    <div className="flex flex-col">
      <nav
        className="flex items-center gap-1 border-b px-6 pt-4"
        style={{ borderColor: 'var(--color-border)' }}
        aria-label="Secciones de Control F29"
      >
        {TABS.map((tab) => {
          const isActive = tab.exact
            ? location.pathname === tab.path
            : location.pathname.startsWith(tab.path);
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={cn(
                '-mb-px border-b-2 px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'border-[color:var(--color-fg)] text-[color:var(--color-fg)]'
                  : 'border-transparent text-[color:var(--color-fg-muted)] hover:text-[color:var(--color-fg)]',
              )}
            >
              {tab.label}
            </Link>
          );
        })}
      </nav>
      <Outlet />
    </div>
  );
}
